import Token from '@/apis/request/token';
import i18next, { getT } from '@/i18n';
import { isBrowser } from '@/utils';
import { dispatch } from '@/redux/index';
import { error } from './globalMessage';
import { findTreeData, findTreePath, mapTree } from '@/utils';

import router, { getRedirectUrl, routePaths } from '@/router';
// import { disconnect } from '@/hook/wallet/index';
const Codes = {
    401: '请重新登录',
    404: '请求地址有误',
};

const redirects = {
    400: async (res: any) => {
        const { data, status, config } = res;
        const { requestOptions: { globalErrorMessage, globalErrorRedirect } = {}, url } = config;
        const { message, statusCode: code, ...more }: { message: string; statusCode: keyof typeof redirects } = data;

        const { t } = await getT('common', i18next.resolvedLanguage);

        if (isBrowser()) {
            error(t(`common.${message}`));
        } else {
            console.log('400:', t(`common.${message}`));
        }
    },
    200: () => {},
    401: (result: any) => {
        // 设置 重定向

        // window.localStorage.setItem('key',)

        const redirectUrl = getRedirectUrl();

        if (routePaths.logIn !== redirectUrl.path && routePaths.dashboard !== redirectUrl.path) {
            localStorage.setItem('redirectUrl', JSON.stringify(redirectUrl));
        }

        // 清楚token
        Token.set('');
        // dispatch(actions.user.setUser({}))

        dispatch.user.setUser({});
        // window.location.href = '/login'
        router.navigate('/log-in');
    },
    404: (result: any) => {
        console.log('redirects 404');
    },
    500: (result: any) => {
        router.navigate(`/system-error/500`);
    },
    503: (result: any) => {
        router.navigate(`/system-error/503`);
    },
};

export { Codes, redirects };
